import React, { createRef } from "react";
import {
  Select,
  Button,
  Space,
  DatePicker,
  Row,
  Col,
  Dropdown,
  Checkbox,
  Modal,
  Table,
  Image,
  Tooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import WorkingHoursReportStore from "../store/WorkingHoursReportStore";
import PythonMessageAlert from "./PythonMessageAlert";
import dayjs from "dayjs";
import VehicleStore from "../store/VehicleStore";
import EmailReportStore from "../store/EmailReportStore";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import config from "../config";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import { hasFeature } from "../utils/componentVisibility";
const features = {
  showWorkingHoursReportFilter: hasFeature("showWorkingHoursReportFilter"),
};
const { RangePicker } = DatePicker;
const { Option } = Select;
class WorkingHoursReport extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.workingHoursReportStore = new WorkingHoursReportStore();
    this.vehicleStore = new VehicleStore(this);
    this.emailReportStore = new EmailReportStore(this);
    this.pythonMessageRef = createRef();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      pageNo: 1,
      offset: 0,
      limit: 50,
      company_name: "",
      listUpdated: 0,
      companyId: "",
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD 23:59:59"),
      selectedVehicles: [],
      selectAllVehicles: false,
      modalVisible: false,
      column: "",
      filter: "",
      Notcompany: false,
      Notasset: false,
      Notdate: false,
      showMonthPopup: false,
      week: "0",
      showSelectAllChk: false,
      pythonReportMessage: false,
      reportmessage: "",
      selectedColumns: [
        {
          // title: "Vehicle Id ",
          title: context.translate("_FLEET_REPORTS_VEHICLEID_"),
          dataIndex: "vehicleNo",
          key: "vehicleNo",
          width: 100,
          ellipsis: { showTitle: true },
          render: (vehicleNo) => (
            <Tooltip placement="topLeft" title={vehicleNo}>
              {vehicleNo}
            </Tooltip>
          ),
          // hidden: true,
        },
        {
          // title: "Date",
          title: context.translate("_FLEET_REPORTS_DATE_"),
          dataIndex: "date",
          key: "date",
          width: 100,
          ellipsis: { showTitle: true },
        },

        {
          // title: "Driver Id",
          title: context.translate("_FLEET_REPORTS_DRIVER_ID_"),
          dataIndex: "driverName",
          key: "driverName",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          // title: "Start Time",
          title: context.translate("_FLEET_START_TIME_"),
          dataIndex: "startTime",
          key: "startTime",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          // title: "Stop Time ",
          title: context.translate("_FLEET_STOP_TIME_"),
          dataIndex: "stopTime",
          key: "stopTime",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          // title: "Duty Time Km ",
          title: context.translate("_FLEET_REPORTS_IN_HOURS_DISTANCE_"),
          dataIndex: "inHoursDistance",
          key: "inHoursDistance",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          // title: "Off Duty km",
          title: context.translate("_FLEET_REPORTS_OUT_HOURS_DISTANCE_"),
          dataIndex: "outHoursDistance",
          key: "outHoursDistance",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          // title: "Distance Km",
          title: context.translate("_FLEET_REPORTS_DISTANCE_"),
          dataIndex: "distanceTravel",
          key: "distanceTravel",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          // title: "Duty Time Duration",
          title: context.translate("_FLEET_REPORTS_IN_HOURS_DURATION_"),
          dataIndex: "inHoursDuration",
          key: "inHoursDuration",
          width: 100,
          ellipsis: { showTitle: true },
          render: (text) => {
            const durationInMinutes = parseInt(text, 10);
            return this.convertMinutesToHHMMSS(durationInMinutes);
          },
        },
        {
          // title: "Off Duty Duration",
          title: context.translate("_FLEET_REPORTS_OUT_HOURS_DURATION_"),
          dataIndex: "outHoursDuration",
          key: "outHoursDuration",
          width: 100,
          ellipsis: { showTitle: true },
          render: (text) => {
            const durationInMinutes = parseInt(text, 10);
            return this.convertMinutesToHHMMSS(durationInMinutes);
          },
        },
        {
          // title: "Duty Time From  ",
          title: context.translate("_DUTY_TIME_FROM_"),
          dataIndex: "dutyTimeFrom",
          key: "dutyTimeFrom",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          // title: "Duty Time To  ",
          title: context.translate("_DUTY_TIME_TO_"),
          dataIndex: "dutyTimeTo",
          key: "dutyTimeTo",
          width: 100,
          ellipsis: { showTitle: true },
        },
        // {
        //   // title: "Groups",
        //   title: context.translate("_GROUPS_"),
        //   dataIndex: "Groups",
        //   key: "Groups",
        //   width: "15%",
        // },
      ],
    };
    this.menuProps = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={Excel}
              ></Image>
              {context.translate("_EXPORT_AS_EXCEL_")}
            </div>
          ),
          key: "excel",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={PDF}
              ></Image>
              {context.translate("_EXPORT_AS_PDF_")}
            </div>
          ),
          key: "pdf",
        },
      ],
      onClick: async (val) => {
        let result = [];
        console.log(val);
        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          var getData = {
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
            // userId: 1,
            week: this.state.week,
            colList: result.toString(),
          };
          if (val.key == "excel") {
            // console.log("afd")
            await this.workingHoursReportStore.exportExcel(getData);
            const isSuccess =
              this.workingHoursReportStore?.pythonReportMessage === true;
            const isError =
              this.workingHoursReportStore?.pythonReportErrorMessage;

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }
          }
          if (val.key == "pdf") {
            await this.workingHoursReportStore.exportpdf(getData);
            const isSuccess =
              this.workingHoursReportStore?.pythonReportMessage === true;
            const isError =
              this.workingHoursReportStore?.pythonReportErrorMessage;

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }
          }
          // if (val.key == "csv") {
          //   this.workingHoursReportStore.exportcsv(getData);
          // }
          // if (val.key == "xml") {
          //   this.workingHoursReportStore.exportxml(getData);
          // }
        }
      },
    };
    this.newColumns = [...this.state.selectedColumns];
  }

  triggerReport = () => {
    this.pythonMessageRef.current.show(); // show the modal
  };

  convertMinutesToHHMMSS = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const seconds = 0; // Assuming seconds are always zero in your case

    // Pad hours and minutes with leading zeros if needed
    const paddedHours = String(hours).padStart(2, "0");
    const paddedMinutes = String(mins).padStart(2, "0");
    const paddedSeconds = String(seconds).padStart(2, "0");

    return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
  };

  async componentDidMount() {
    this.setState({ pageSize: 50 });
    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }
    if (Number(this.props.getUserData().isadmin) === 1) {
      await this.vehicleStore.getVehicleGroup({
        companyId: this.props.getUserData().userCompanyId,
        userId: this.props.getUserData().userId,
        isadmin: this.props.getUserData().isadmin,
      });
    }

    await this.setState({ column: this.state.selectedColumns });
  }

  async handleTableChange(pagination, filters, sorter) {
    //   console.log(pagination);
    await this.setState({
      pageNo: pagination.current,
      pageSize: pagination.pageSize,
    });
    // this.handleSearch();
    await this.showData();
  }
  onDateTimeChange = (dates) => {
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
      this.setState({
        fromdateStdTime: dates[0],
        fromDate: dates[0]?.format(format),
        toDate: dates[1]?.format(format),
      });
    } else {
      this.setState({ fromDate: "", toDate: "" });
    }
  };
  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    await this.setState({ currentPage: 1, companyId: comp.value });
    await this.setState({ selectedVehicles: [], selectAllVehicles: false });
    await this.vehicleStore.getVehiclesCompanyId(comp.value);
    await this.setState({ listUpdated: 1 });
    // await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ Notasset: false });
    await this.workingHoursReportStore.loadData({
      offset: (this.state.pageNo - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      pageNo: this.state.pageNo,
      vehicleId: this.state.selectedVehicles,
    });

    await this.setState({ listUpdated: 1 }); //need to reload data
  }

  showData = async () => {
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (this.state.selectedVehicles?.length === 0) {
      this.setState({ Notasset: true });
    } else {
      this.setState({ Notasset: false });
    }
    if (!this.state.fromDate) {
      this.setState({ Notdate: true });
    } else {
      this.setState({ Notdate: false });
    }

    if (
      this.state.companyId &&
      this.state.selectedVehicles?.length > 0 &&
      this.state.fromDate &&
      this.state.toDate
    ) {
      // this.setState({mandatory:false})
      this.setState({ Notcompany: false, Notasset: false });
      if (this.checkFromDate(this.state.fromdateStdTime)) {
        await this.workingHoursReportStore.loadData({
          offset: (this.state.pageNo - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
          vehicleId: this.state.selectedVehicles,
          pageNo: this.state.pageNo,
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          week: this.state.week,
        });
        this.setState({ loadData: 1 });
        // console.log(this.state.fromDate,this.state.toDate,)
      }
    }
  };
  handleAllSelectVehicles = async (e) => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId?.map(
        (val) => {
          return val.vehicleId;
        }
      );
      await this.setState({ selectedVehicles: allVehicles });
    } else {
      await this.setState({ selectedVehicles: [] });
    }
  };

  handleCheckboxChange = async (column) => {
    console.log(column);
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state?.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      console.log(filtered);
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      console.log("adsf");
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };

  addMonths = (date, months) => {
    var indx = dayjs().month() + -6;
    return dayjs().month(indx);
  };
  checkFromDate(dates) {
    var fromDate = dates;
    var pdate = this.addMonths();
    if (pdate > fromDate) {
      this.setState({ showMonthPopup: true });
      return false;
    } else {
      return true;
    }
  }

  getSubGroup = async (val) => {
    const subgroupData = await this.vehicleStore.getVehicleSubGroup({
      deviceGroupId: val,
      deviceSubGroupId: null,
      companyId: this.state.companyId,

      userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
      isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
      subgroup: val,
    });

    this.setState({ loadData: 1 });
  };

  getSubGroupVehicles = async (val) => {
    const subgroupData = await this.vehicleStore.getVehicleSubGroup({
      deviceGroupId: this.state.deviceGroupId,
      deviceSubGroupId: val,
      companyId: this.state.companyId,

      userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
      isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
    });
    this.setState({ loadData: 1 });
  };

  expandedRowRender = (x) => {
    const columns = [
      {
        // title: "Vehicle Id ",
        title: this.context.translate("_FLEET_REPORTS_VEHICLEID_"),
        dataIndex: "vehicleNo",
        key: "vehicleNo",
        width: 100,
        ellipsis: { showTitle: true },
      },
      {
        // title: "Date",
        title: this.context.translate("_FLEET_REPORTS_DATE_"),
        dataIndex: "date",
        key: "date",
        width: 100,
        ellipsis: { showTitle: true },
      },

      {
        // title: "Driver Id",
        title: this.context.translate("_FLEET_REPORTS_DRIVER_ID_"),
        dataIndex: "driverName",
        key: "driverName",
        width: 100,
        ellipsis: { showTitle: true },
      },
      {
        // title: "Start Time",
        title: this.context.translate("_FLEET_START_TIME_"),
        dataIndex: "startTime",
        key: "startTime",
        width: 100,
        ellipsis: { showTitle: true },
        render: (value) => {
          if (value) {
            const formattedDateTime = dayjs(value).format(
              "DD-MM-YYYY hh:mm:ss A"
            );
            return <>{formattedDateTime}</>;
          } else {
            return <></>;
          }
        },
      },
      {
        // title: "Stop Time ",
        title: this.context.translate("_FLEET_STOP_TIME_"),
        dataIndex: "stopTime",
        key: "stopTime",
        width: 100,
        ellipsis: { showTitle: true },
        render: (value) => {
          if (value) {
            const formattedDateTime = dayjs(value).format(
              "DD-MM-YYYY hh:mm:ss A"
            );
            return <>{formattedDateTime}</>;
          } else {
            return <></>;
          }
        },
      },
      {
        // title: "Duty Time Km ",
        title: this.context.translate("_FLEET_REPORTS_IN_HOURS_DISTANCE_"),
        dataIndex: "inHoursDistance",
        key: "inHoursDistance",
        width: 100,
        ellipsis: { showTitle: true },
      },
      {
        // title: "Off Duty km",
        title: this.context.translate("_FLEET_REPORTS_OUT_HOURS_DISTANCE_"),
        dataIndex: "outHoursDistance",
        key: "outHoursDistance",
        width: 100,
        ellipsis: { showTitle: true },
      },
      {
        // title: "Distance Km",
        title: this.context.translate("_FLEET_REPORTS_DISTANCE_"),
        dataIndex: "distanceTravel",
        key: "distanceTravel",
        width: 100,
        ellipsis: { showTitle: true },
      },
      {
        // title: "Duty Time Duration",
        title: this.context.translate("_FLEET_REPORTS_IN_HOURS_DURATION_"),
        dataIndex: "inHoursDuration",
        key: "inHoursDuration",
        width: 100,
        ellipsis: { showTitle: true },
        render: (text) => {
          const durationInMinutes = parseInt(text, 10);
          return this.convertMinutesToHHMMSS(durationInMinutes);
        },
      },
      {
        // title: "Off Duty Duration",
        title: this.context.translate("_FLEET_REPORTS_OUT_HOURS_DURATION_"),
        dataIndex: "outHoursDuration",
        key: "outHoursDuration",
        width: 100,
        ellipsis: { showTitle: true },
        render: (text) => {
          const durationInMinutes = parseInt(text, 10);
          return this.convertMinutesToHHMMSS(durationInMinutes);
        },
      },
      {
        // title: "Duty Time From  ",
        title: this.context.translate("_DUTY_TIME_FROM_"),
        dataIndex: "dutyTimeFrom",
        key: "dutyTimeFrom",
        width: 100,
        ellipsis: { showTitle: true },
      },
      {
        // title: "Duty Time To  ",
        title: this.context.translate("_DUTY_TIME_TO_"),
        dataIndex: "dutyTimeTo",
        key: "dutyTimeTo",
        width: 100,
        ellipsis: { showTitle: true },
      },
      // {
      //   // title: "Groups",
      //   title: context.translate("_GROUPS_"),
      //   dataIndex: "Groups",
      //   key: "Groups",
      //   width: "15%",
      // },
    ];

    const totalColumns = [
      {
        // title: "Vehicle Id ",
        title: this.context.translate("_FLEET_REPORTS_VEHICLEID_"),
        dataIndex: "vehicleNo",
        key: "vehicleNo",
        width: "15%",
        render: () => {
          <>Total</>;
        },
      },
      {
        // title: "Date",
        title: this.context.translate("_FLEET_REPORTS_DATE_"),
        dataIndex: "",
        key: "date",
        width: "15%",
      },

      {
        // title: "Driver Id",
        title: this.context.translate("_FLEET_REPORTS_DRIVER_ID_"),
        dataIndex: "",
        key: "driverName",
        width: "15%",
      },
      {
        // title: "Start Time",
        title: this.context.translate("_FLEET_START_TIME_"),
        dataIndex: "startTime",
        key: "startTime",
        width: "15%",
        render: (value) => {
          if (value) {
            const formattedDateTime = dayjs(value).format("DD-MM-YYYY");
            return <>{formattedDateTime}</>;
          } else {
            return <></>;
          }
        },
      },
      {
        // title: "Stop Time ",
        title: this.context.translate("_FLEET_STOP_TIME_"),
        dataIndex: "stopTime",
        key: "stopTime",
        width: "15%",
        render: (value) => {
          if (value) {
            const formattedDateTime = dayjs(value).format("DD-MM-YYYY");
            return <>{formattedDateTime}</>;
          } else {
            return <></>;
          }
        },
      },
      {
        // title: "Duty Time Km ",
        title: this.context.translate("_FLEET_REPORTS_IN_HOURS_DISTANCE_"),
        dataIndex: "inHoursDistance",
        key: "inHoursDistance",
        width: "15%",
      },
      {
        // title: "Off Duty km",
        title: this.context.translate("_FLEET_REPORTS_OUT_HOURS_DISTANCE_"),
        dataIndex: "outHoursDistance",
        key: "outHoursDistance",
        width: "15%",
      },
      {
        // title: "Distance Km",
        title: this.context.translate("_FLEET_REPORTS_DISTANCE_"),
        dataIndex: "distanceTravel",
        key: "distanceTravel",
        width: "15%",
      },
      {
        // title: "Duty Time Duration",
        title: this.context.translate("_FLEET_REPORTS_IN_HOURS_DURATION_"),
        dataIndex: "inHoursDuration",
        key: "inHoursDuration",
        width: "15%",
        render: (text) => {
          const durationInMinutes = parseInt(text, 10);
          return this.convertMinutesToHHMMSS(durationInMinutes);
        },
      },
      {
        // title: "Off Duty Duration",
        title: this.context.translate("_FLEET_REPORTS_OUT_HOURS_DURATION_"),
        dataIndex: "outHoursDuration",
        key: "outHoursDuration",
        width: "15%",
        render: (text) => {
          const durationInMinutes = parseInt(text, 10);
          return this.convertMinutesToHHMMSS(durationInMinutes);
        },
      },
      {
        // title: "Duty Time From  ",
        title: this.context.translate("_DUTY_TIME_FROM_"),
        dataIndex: "",
        key: "dutyTimeFrom",
        width: "15%",
      },
      {
        // title: "Duty Time To  ",
        title: this.context.translate("_DUTY_TIME_TO_"),
        dataIndex: "",
        key: "dutyTimeTo",
        width: "15%",
      },
      // {
      //   // title: "Groups",
      //   title: context.translate("_GROUPS_"),
      //   dataIndex: "Groups",
      //   key: "Groups",
      //   width: "15%",
      // },
    ];

    return (
      <>
        <div>
          <p>{`Vehicle No: ${x.vehicleNo}`}</p>
        </div>
        <Table
          showHeader={false}
          bordered
          columns={columns}
          scroll={{ x: 50 }}
          dataSource={[x]}
          pagination={false}
        />
        <Table
          showHeader={false}
          bordered
          columns={totalColumns}
          scroll={{ x: 50 }}
          dataSource={[x]}
          pagination={false}
        />
      </>
    );
  };
  refreshList = async () => {
    await this.setState({ loading: false, pageNo: 1, currentPage: 1 });
    await this.showData();
  };

  render() {
    return (
      <>
        {/* <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_WORKING_HOURS_REPORT_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>

                <Dropdown
                  menu={this.menuProps}
                  disabled={
                    this.workingHoursReportStore?.workingHoursReport?.length > 0
                      ? false
                      : true
                  }
                >
                  <Button
                    className="exportDropdown"
                    //  style={{ backgroundColor: config.activeColor }}
                  >
                    <Space>
                      {this.context.translate("_EXPORT_")}
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </Space>
            </Col>
          </Row>
        </div> */}
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  allowClear={true}
                  className="searchInput"
                  onChange={(value) => this.handleChange(value)}
                  style={{ width: 150 }}
                  // style={companyInputStyle}
                  status={this.state.Notcompany ? "error" : false}
                />

                {this.props.getUserData().isadmin === 1 && (
                  <DeviceGroupsForVehicles
                    vehicleStore={this.vehicleStore}
                    setLoadDta={() => this.setState({ loadData: 1 })}
                    resetVehicles={() =>
                      this.setState({
                        selectedVehicles: [],
                        selectAllVehicles: false,
                      })
                    }
                  //  This={this}
                  />
                )}

                <Checkbox
                  checked={this.state.selectAllVehicles}
                  onChange={async (e) => {
                    await this.setState({
                      selectAllVehicles: e.target.checked,
                    });
                    if (this.state.selectAllVehicles) {
                      await this.setState({
                        Notasset: false,
                      });
                    }
                    // console.log(e.target.checked);
                    await this.handleAllSelectVehicles();
                  }}
                />

                {this.context.translate("_ALL_")}
                {"  "}

                <Select
                  maxTagCount="responsive"
                  value={this.state.selectedVehicles}
                  className="searchInput"
                  onChange={(val) => {
                    this.setState({ selectedVehicles: val });
                    if (
                      this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                      val.length
                    ) {
                      this.setState({ selectAllVehicles: false });
                    } else {
                      this.setState({ selectAllVehicles: true });
                    }

                    if (val?.length > 1) {
                      console.log(val?.length > 1);
                      this.setState({ showAlertPopup: true });
                    }
                  }}
                  style={{ width: 170 }}
                  showSearch
                  status={this.state.Notasset ? "error" : false}
                  mode="multiple"
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                  )}
                  filterOption={(inputValue, option) => {
                    if (option.children) {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) >= 0
                      );
                    }
                  }}
                >
                  {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                    return (
                      <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                    );
                  })}
                </Select>

                {!features.showWorkingHoursReportFilter && (<Select
                  placeholder="Week"
                  style={{ width: 120 }}
                  className="searchInput"
                  onSelect={(val) => {
                    this.setState({ week: val });
                  }}
                  defaultValue={"0"}
                >
                  <Select.Option value="0">
                    {this.context.translate("All")}
                  </Select.Option>
                  <Select.Option value="1">
                    {this.context.translate("_SUNDAY_")}
                  </Select.Option>
                  <Select.Option value="2">
                    {this.context.translate("_MONDAY_")}
                  </Select.Option>
                  <Select.Option value="3">
                    {this.context.translate("_TUESDAY_")}
                  </Select.Option>
                  <Select.Option value="4">
                    {this.context.translate("_WEDNESDAY_")}
                  </Select.Option>
                  <Select.Option value="5">
                    {this.context.translate("_THURSDAY_")}
                  </Select.Option>
                  <Select.Option value="6">
                    {this.context.translate("_FRIDAY_")}
                  </Select.Option>
                  <Select.Option value="7">
                    {this.context.translate("_SATURDAY_")}
                  </Select.Option>
                </Select>)}
                <RangePicker
                  placeholder={[
                    this.context.translate("_FROM_DATE_TIME_"),
                    this.context.translate("_TO_DATETIME_"),
                  ]}
                  format="DD-MM-YYYY hh:mmA"
                  style={{ width: 400, borderRadius: "25px" }}
                  onChange={(val) => {
                    this.onDateTimeChange(val);
                  }}
                  // disabledDate={(current) => {
                  //   return current && current > dayjs();
                  // }}
                  showTime={{
                    format: "h:mmA",
                    defaultValue: [
                      dayjs().startOf("day"),
                      dayjs().endOf("day"),
                    ],
                  }}
                  status={this.state.Notdate ? "error" : false}
                  defaultValue={[dayjs().startOf("day"), dayjs().endOf("day")]}
                />

                <Button
                  type="primary"
                  onClick={async () => {
                    await this.setState({ pageSize: 50, pageNo: 1 });
                    await this.showData();
                  }}
                >
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>
                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>
              </Space>
            </Col>

            <Col span={4}>
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.workingHoursReportStore?.workingHoursReport?.length > 0
                      ? false
                      : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.menuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Col>
          </Row>

          <Modal
            open={this.state.modalVisible}
            width={350}
            // title="Select Columns"
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>

          <ListTable
            //  expandable={{
            //   // expandedRowRender: (record) => <this.RowSummary record={record} />,
            //   rowExpandable: (record) => record.name !== 'Not Expandable', // Optionally control which rows can be expanded
            // }}
            // expandable={{
            //   expandedRowRender: (record) => this.expandedRowRender(record), // Pass record as a parameter
            // }}

            // expandable={{
            //   expandedRowRender: (record) => (
            //     <div>
            //       {/* Custom content inside the div */}
            //       <p>{`Name: ${record.name}`}</p>
            //       <p>{`Start Time: ${record.startTime}`}</p>
            //       {/* Add more fields as needed */}
            //     </div>
            //   ),
            //   rowExpandable: (record) => record.name !== 'Not Expandable', // Optionally control which rows can be expanded
            // }}
            key={this.state.selectedColumns.length}
            rowKey="startTime"
            currentPage={this.state.pageNo}
            pageSize={this.state.pageSize}
            total={this.workingHoursReportStore?.total}
            columns={this.state.selectedColumns}
            dataSource={this.workingHoursReportStore?.workingHoursReport}
            loading={this.workingHoursReportStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        <Modal
          width={350}
          className="alert-model"
          title={
            <div>
              {" "}
              <i
                style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                class="bi bi-exclamation-triangle"
              ></i>{" "}
              {/* Alert */}
              {this.context.translate("_FLEET_ALERT_")}
            </div>
          }
          open={this.state.showMonthPopup}
          onOk={() => this.setState({ showMonthPopup: false })}
          onCancel={() => this.setState({ showMonthPopup: false })}
          footer={false}
        >
          {/* For reports prior to 6 months please contact administrator */}
          {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
        </Modal>
        {
          <div>
            <PythonMessageAlert
              ref={this.pythonMessageRef}
              message={this.state.reportmessage}
            />
          </div>
        }
      </>
    );
  }
}
WorkingHoursReport.contextType = StoreContext;
export default observer(withRouter(WorkingHoursReport));
